import request from '@/router/axios';
//查询
export function getApprListpage(obj) {
  return request({
    url: '/workflow/page',
    method: 'POST',
    data: obj,
  });
}
//查询
export function getApperNodeListpage(obj) {
  return request({
    url: '/appr/process/node/page',
    method: 'POST',
    data: obj,
  });
}
//新增
export function add(obj) {
  return request({
    url: '/appr/add',
    method: 'post',
    data: obj,
  });
}
//更新
export function updateProcess(obj) {
  return request({
    url: '/workflow/update',
    method: 'post',
    data: obj,
  });
}
//更新
export function update(obj) {
  return request({
    url: '/appr/update',
    method: 'post',
    data: obj,
  });
}

//查询该员工是否已被设置为其他级别审批人
export function queryEmpIsExist(obj) {
  return request({
    url: '/appr/queryEmpIsExist',
    method: 'post',
    data: obj
  })
}

//删除
export function delApprInfoById(id) {
  return request({
    url: '/workflow/delete/'+id,
    method: 'get',
  })
}

//查询当前客户下所有员工
export function getAllEmpByCusId(obj) {
  return request({
    url: '/emp/getAllEmpByCusId',
    method: 'post',
    data: obj
  })
}
